"use client"

import { AuthFormHeading } from "./auth-form-heading"

import { zodResolver } from "@hookform/resolvers/zod"
import { useForm } from "react-hook-form"
import { z } from "zod"

import { LoadingButton } from "@/shared/components/feedback/loading-button"
import { FieldInputOTP } from "@/shared/components/form/form-fields"
import { Button } from "@/shared/components/ui/button"
import { Form } from "@/shared/components/ui/form"

const OTP_UZUNLUK = 6

const formSchema = z.object({
  otp: z.string().length(OTP_UZUNLUK, "6 haneli kodu girin"),
})

type FormValues = z.infer<typeof formSchema>

interface KayitOtpStepProps {
  email: string | null
  isSubmitting: boolean
  hataMesaji: string | null
  kalanDeneme: number | null
  onSubmit: (otp: string) => void
  onDegisiklik: () => void
  onYenidenBasla: () => void
}

export function KayitOtpStep({
  email,
  isSubmitting,
  hataMesaji,
  kalanDeneme,
  onSubmit,
  onDegisiklik,
  onYenidenBasla,
}: KayitOtpStepProps) {
  const form = useForm<FormValues>({
    resolver: zodResolver(formSchema),
    defaultValues: { otp: "" },
  })

  const otp = form.watch("otp") ?? ""

  return (
    <Form {...form}>
      <form
        onSubmit={form.handleSubmit((values) => onSubmit(values.otp))}
        className="space-y-8"
      >
        <AuthFormHeading title="E-postanızı doğrulayın">
            {email ? <>{email} adresine</> : "E-posta adresinize"} gönderdiğimiz 6 haneli
            kodu girin. Kod 10 dakika geçerlidir.
          </AuthFormHeading>

        <FieldInputOTP
          name="otp"
          className="justify-items-center"
          gapClassName="space-x-2"
          slotClassName="rounded-md border-l"
          onValueChange={onDegisiklik}
        />

        {hataMesaji && (
          <p role="alert" className="text-center text-sm text-destructive">{hataMesaji}</p>
        )}
        {kalanDeneme !== null && kalanDeneme > 0 && !hataMesaji && (
          <p className="text-center text-sm text-muted-foreground">
            Kalan deneme hakkınız: {kalanDeneme}
          </p>
        )}

        <LoadingButton
          type="submit"
          className="w-full"
          loading={isSubmitting}
          disabled={otp.length !== OTP_UZUNLUK}
        >
          Doğrula
        </LoadingButton>

        <Button
          type="button"
          variant="ghost"
          className="w-full"
          onClick={onYenidenBasla}
        >
          Bilgileri değiştir / yeni kayıt oluştur
        </Button>
      </form>
    </Form>
  )
}
